// extracted by mini-css-extract-plugin
export default {"block":"DownloadBlock_block__qnPFO","title":"DownloadBlock_title__oTSl1","actions":"DownloadBlock_actions__VxgLK","action":"DownloadBlock_action__qWosG"};